<template>
  <header class="app-header">
    <div class="container">
      <router-link to="/" class="logo">
        <h1>🎵 SoundBattle</h1>
      </router-link>
      
      <nav class="nav-links">
        <router-link to="/settings" class="nav-link">
          ⚙️
        </router-link>
      </nav>
    </div>
  </header>
</template>

<script setup lang="ts">
// Keine Logik erforderlich
</script>

<style scoped lang="scss">
.app-header {
  @apply fixed top-0 left-0 right-0;
  background: rgba($background-dark, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba($spotify-gray, 0.2);
  z-index: $z-header;
  padding: $spacing-md $spacing-lg;
}

.container {
  @apply max-w-screen-xl mx-auto;
  @apply flex items-center justify-between;
}

.logo {
  @apply text-white no-underline;
  
  h1 {
    @apply text-2xl font-bold m-0;
    background: linear-gradient(135deg, $spotify-green, lighten($spotify-green, 20%));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
}

.nav-links {
  @apply flex gap-4;
}

.nav-link {
  @apply text-2xl text-gray-400;
  @apply hover:text-white;
  @apply transition-colors duration-300;
  text-decoration: none;
}
</style>